module.exports = __webpack_public_path__ + "img/dots.c97ab06b.svg";